import { type CSSProperties } from 'react'

/**
 * One line of placeholder text. Put it inside the element whose text it
 * stands in for, so that element's font size and line height decide its
 * height. Several in a row stand in for wrapped text.
 */
export function SkeletonLine({ width = '100%' }: { width?: CSSProperties['width'] }) {
  return <span className="skeleton skeleton-line" style={{ width }} aria-hidden="true" />
}
